/* ================================================== */
/* STICKYFILL
/* ================================================== */

$(document).ready(function(){
	$('html:not([data-browser="ie-11"]) .sticky').Stickyfill();
});